export const SESSION_IDS = {
    WHOAMI: 'whoami',
    ABOUT: 'about',
    SKILLS: 'skills',
    CONTACT: 'contact',
    PROJECTS: 'projects'
}

export const SESSION = [
    { id: SESSION_IDS.WHOAMI, cmd: 'whoami', type: 'whoami' },
    { id: SESSION_IDS.ABOUT, cmd: 'cat about.md', type: 'about' },
    { id: SESSION_IDS.SKILLS, cmd: 'ls skills/', type: 'skills' },
    { id: SESSION_IDS.CONTACT, cmd: 'cat contact.txt', type: 'contact' },
    { id: SESSION_IDS.PROJECTS, cmd: 'cat projects.log', type: 'projects' }
]

export const EASTER_EGG_CMD = 'sudo hire-me'

export const PAGE_TO_COMMANDS = {
    about: [SESSION_IDS.ABOUT, SESSION_IDS.SKILLS],
    projects: [SESSION_IDS.PROJECTS],
    contact: [SESSION_IDS.CONTACT]
}
